import './node_modules/swiper/swiper.scss';
import './node_modules/swiper/swiper-bundle.css';
import './node_modules/swiper/swiper-bundle.min.css';
import './src/assets/sass/main.scss';
import './src/styles/global.css';
import './webview';
import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();
